import { render, staticRenderFns } from "./targetPeople.vue?vue&type=template&id=09406bdc&scoped=true&"
import script from "./targetPeople.vue?vue&type=script&lang=js&"
export * from "./targetPeople.vue?vue&type=script&lang=js&"
import style0 from "./targetPeople.vue?vue&type=style&index=0&id=09406bdc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09406bdc",
  null
  
)

export default component.exports